// @flow
import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 40px;
  padding-bottom: 40px;
  border-bottom: 1px solid ${props => props.theme.colors.lightGrey};
  &:last-child {
    margin-bottom: 0px;
  }
`;

export const ContentWrapper = styled(Link)`
  flex: 1;
  display: block;
  &:link,
  &:hover,
  &:active,
  &:visited {
    color: black;
    text-decoration: none;
  }
  &:hover {
    text-decoration: underline;
    text-decoration-color: ${props => props.theme.colors.green};
  }
`;

export const Title = styled.h2`
  margin-top: 0px;
  font-family: ${props => props.theme.fontBold};
`;

export const Meta = styled.div`
  color: ${props => props.theme.colors.greyLight};
`;

export const ChevronButton = styled.button`
  border: none;
  padding: 10px;
  border-radius: 3px;
  margin-left: 20px;
  width: 44px;
  color: ${props => (props.isUpvoted ? 'white' : 'black')};
  background-color: ${props =>
    props.isUpvoted ? props.theme.colors.green : props.theme.colors.lightGrey};
  transition: 0.3s ease;
  cursor: pointer;
  &:hover {
    background-color: ${props => props.theme.colors.green};
    color: white;
  }
  &:active {
    transform: scale(1.05);
  }
  &:focus {
    outline: none;
  }
  &:first-child {
    margin-bottom: 20px;
  }
  &:disabled {
    background-color: ${props => props.theme.colors.lightGrey};
    opacity: 0.5;
    cursor: wait;
    color: black;
  }
`;

export const Chevron = styled.div`
  font-size: ${props => (props.isUpvoted ? '26px' : '36px')};
  margin-bottom: ${props => (props.isUpvoted ? '10px' : '0')};
`;

export const Count = styled.div`
  text-align: center;
  display: block;
  font-size: 18px;
`;

export const ErrorText = styled.h2`
  text-align: center;
`;



// WEBPACK FOOTER //
// ./src/pages/feed/feed.styles.js